import { default as firebase } from "common/Firebase";
import { LoginStore } from "modules/login/LoginStore";
import { LoginService } from "modules/login/LoginService";
import { ProfileService } from "modules/profile/ProfileService";

class Service {
  async verifyPassword(oobCode, callback?): Promise<void> {
    let auth = firebase.auth();
    auth
      .verifyPasswordResetCode(oobCode.toString())
      .then((userEmail) => {
        if (callback) callback(true, { email: userEmail });
      })
      .catch(function (error) {
        if (callback) callback(false, error);
      });
  }

  async verifyEmail(oobCode, callback?): Promise<void> {
    let auth = firebase.auth();
    auth
      .checkActionCode(oobCode.toString())
      .then((actionCodeInfo) => {
        let userEmail = actionCodeInfo.data.email;
        if (callback) {
          firebase
            .auth()
            .applyActionCode(oobCode.toString())
            .then(() => {
              callback(true, userEmail);
            });
        }
      })
      .catch(function (error) {
        if (callback) callback(false, error);
      });
  }

  async confirmResetPassword(
    oobCode,
    email,
    password,
    callback?
  ): Promise<void> {
    firebase
      .auth()
      .confirmPasswordReset(oobCode, password)
      .then(() => {
        firebase
          .auth()
          .signInWithEmailAndPassword(email, password)
          .then(() => {
            if (callback) callback(true, ProfileService.getAuthData());
          })
          .catch(function (error) {
            if (callback) callback(false, error);
          });
      })
      .catch(function (error) {
        if (callback) callback(false, error);
      });
  }

  async loadUserFromEmail(email, verified, callback?): Promise<void> {
    let user = await LoginService.FetchUserByEmail(email);
    if (verified) {
      LoginService.UpdateEmailVerified(user);
    }
    if (callback) {
      callback(user);
    }
  }

  async loginUser(callback?): Promise<void> {
    await LoginStore.loadCurrentUser().then(() => {
      if (callback) callback();
    });
  }
}

let AccountService = new Service();

export { AccountService };



// WEBPACK FOOTER //
// ./src/modules/account/AccountService.ts